export default __webpack_public_path__ + "static/media/money-back@3x.a12f4af4.png";